// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"8908549cc356f86493dd","293":"0caff2b643d3c0be8f36","454":"a76b2b080fc4ff5b0f23"}[chunkId] + ".js";
};